import { useContext } from 'react';

import { CitContext } from './context';

const useCit = () =>
  useContext(CitContext);

export default useCit;
